import produce from 'immer';

import {
  GET_REPORTS_URL_FAILURE,
  GET_REPORTS_URL_REQUEST,
  GET_REPORTS_URL_SUCCESS,
  GET_WEIGHT_CHANGE_DATA_REQUEST,
  GET_WEIGHT_CHANGE_DATA_SUCCESS,
  GET_WEIGHT_CHANGE_DATA_FAILURE,
  GET_BMI_DATA_REQUEST,
  GET_BMI_DATA_SUCCESS,
  GET_BMI_DATA_FAILURE,
  GET_TARGET_WEIGHT_DATA_REQUEST,
  GET_TARGET_WEIGHT_DATA_SUCCESS,
  GET_TARGET_WEIGHT_DATA_FAILURE,
  GET_WBGT_DATA_REQUEST,
  GET_WBGT_DATA_SUCCESS,
  GET_WBGT_DATA_FAILURE,
} from 'modules/reports/reports.actions';

const initialState = {
  isLoading: false,
  reportsUrl: null,
  isExportLoading: false,
  weightChangeData: null,
  bmiData: null,
  targetWeightData: null,
  wbgtData: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_REPORTS_URL_SUCCESS:
      draft.reportsUrl = action.response.url;
      draft.isLoading = false;
      break;

    case GET_REPORTS_URL_FAILURE:
      draft.isLoading = false;
      break;

    case GET_REPORTS_URL_REQUEST:
      draft.isLoading = true;
      break;

    case GET_WEIGHT_CHANGE_DATA_REQUEST:
    case GET_BMI_DATA_REQUEST:
    case GET_TARGET_WEIGHT_DATA_REQUEST:
    case GET_WBGT_DATA_REQUEST:
      draft.isExportLoading = true;
      break;

    case GET_WEIGHT_CHANGE_DATA_SUCCESS:
      draft.weightChangeData = action.response;
      draft.isExportLoading = false;
      break;

    case GET_BMI_DATA_SUCCESS:
      draft.bmiData = action.response;
      draft.isExportLoading = false;
      break;

    case GET_TARGET_WEIGHT_DATA_SUCCESS:
      draft.targetWeightData = action.response;
      draft.isExportLoading = false;
      break;

    case GET_WBGT_DATA_SUCCESS:
      draft.wbgtData = action.response;
      draft.isExportLoading = false;
      break;

    case GET_WEIGHT_CHANGE_DATA_FAILURE:
    case GET_BMI_DATA_FAILURE:
    case GET_TARGET_WEIGHT_DATA_FAILURE:
    case GET_WBGT_DATA_FAILURE:
      draft.isExportLoading = false;
      break;

    default:
      break;
  }
}, initialState);
